/* Unicorn Lab Pro Rules */
(function () {
  'use strict';

  const money = (value) => {
    const amount = Number(value || 0);
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount);
  };

  const moneyAUD = (value) => `${money(value)} AUD`;

  const RULES = {
    fixedProductDiscounts: {
      '5ml-round-clear-dropper-bottle-filled': 49.00,
      '5ml-round-frosted-dropper-bottle-filled': 49.00,
      '5ml-flat-shoulder-clear-dropper-bottle-filled': 53.00,
      '5ml-flat-shoulder-frosted-dropper-bottle-filled': 53.00,
      '15ml-round-clear-dropper-bottle-filled': 65.00,
      '15ml-round-frosted-dropper-bottle-filled': 65.00,
      '15ml-square-clear-dropper-bottle-filled': 66.00,
      '15ml-square-frosted-bottle-filled': 66.00,
      '15ml-flat-shoulder-clear-dropper-bottle-filled': 66.00,
      '15ml-flat-shoulder-frosted-dropper-bottle-filled': 66.00,
      '3ml-pink-twist-pen-filled': 37.00,
      '3ml-pink-cuticle-oil-pen-filled-x10': 37.00,
      '3ml-clear-twist-pen-filled': 47.00
    },
    lockedProductHandles: ['wholesale-bottle-builder', '50ml-refill-oil', '100ml-oil'],
    proAccountUrl: '/pages/wholesale-pro-accounts',
    oilSizeRules: {
      sample_1ml: { label: '1ml Sample', maxPerVariant: 1, tiers: [{ qty: 1, price: 1.00 }] },
      pen_2_5ml: { label: '2.5ml Clear Pen', tiers: [{ qty: 1, price: 6.50 }] },
      pen_pink: { label: '2ml Pink Pen', tiers: [{ qty: 1, price: 5.00 }] },
      pen_3ml: { label: '2ml & 3ml Pen', tiers: [{ qty: 1, price: 5.20 }] },
      mini_5ml: { label: '5ml Mini', tiers: [{ qty: 40, price: 5.20 }, { qty: 20, price: 6.10 }, { qty: 1, price: 6.80 }] },
      pack_5ml_10: { label: '5ml 10-Pack', tiers: [{ qty: 1, price: 55.00 }] },
      roller_10ml: { label: '10ml Roller', tiers: [{ qty: 1, price: 10.00 }] },
      bottle_15ml: { label: '15ml', tiers: [{ qty: 100, price: 7.50 }, { qty: 50, price: 8.40 }, { qty: 40, price: 8.90 }, { qty: 30, price: 9.50 }, { qty: 20, price: 10.00 }, { qty: 1, price: 11.00 }] },
      bottle_30ml: { label: '30ml', tiers: [{ qty: 40, price: 13.60 }, { qty: 20, price: 14.00 }, { qty: 10, price: 14.80 }, { qty: 1, price: 15.20 }] }
    },
    fixedProductPrices: {
      '3ml-pink-twist-pen': 1.60,
      '3ml-clear-twist-pen': 1.50,
      '5ml-round-bottle-frosted': 1.50,
      '5ml-round-bottle-clear': 1.50,
      '5ml-flat-shoulder-bottle-clear': 1.60,
      '5ml-flat-shoulder-bottle-frosted': 1.60,
      '15ml-round-bottle-frosted': 1.70,
      '15ml-round-bottle-clear': 1.70,
      '15ml-flat-shoulder-bottle-frosted': 2.00,
      '15ml-flat-shoulder-bottle-clear': 2.00,
      '15ml-square-bottle-clear': 1.70,
      '15ml-square-bottle-frosted': 1.70,
      '15ml-mystery-oil-pack-x20': 184.80,
      '30ml-mystery-oil-pack-x20': 252.00,
      'mini-mystery-oil-pack-x-20': 105.00,
      'mystery-cuticle-oil-pen-bundle': 47.25,
      '15ml-mystery-oil-pack-x40': 330.96,
      '30ml-mystery-oil-pack-x40': 456.96,
      'mini-mystery-oil-pack-x40': 189.00,
      '15ml-mystery-oil-pack-x-20-copy': 252.00,

      'mini-candy-collection-1': 25.20,
      '30ml-floral-collection-1': 25.20,
      'mini-fragrance-collection': 25.20,
      'mini-drinks-collection': 25.20,
      'mini-tropical-collection': 25.20,
      'mini-pink-collection': 25.20,
      'mini-fruit-collection-2': 25.20,
      'mini-christmas-cuticle-oil-collection-5ml': 25.20,
      'mini-summer-fruit-collection': 25.20,
      'mini-neon-collection': 25.20,

      '15ml-pink-collection': 41.99,
      '15ml-floral-collection': 41.99,
      '15ml-candy-collection-1': 41.99,
      '15ml-drinks-collection': 41.99,
      '15ml-tropical-collection': 41.99,
      '15ml-fruit-collection-2': 41.99,
      '15ml-fragrance-collection': 41.99,
      '15ml-neon-collection': 41.99,
      '15ml-summer-fruit-collection': 41.99,

      '30ml-candy-collection-1': 57.74,
      '30ml-pink-collection': 57.74,
      '30ml-summer-fruit-collection': 57.74,
      '30ml-fragrance-collection': 57.74,
      '30ml-floral-collection': 57.74,
      '30ml-drinks-collection': 57.74,
      '30ml-neon-collection': 57.74,
      '30ml-tropical-collection': 57.74,
      '30ml-fruit-collection-2': 57.74
    },
    collectionDiscounts: {
      'bling-lab': { label: 'Bling Lab', tiers: [{ qty: 30, percent: 50 }, { qty: 20, percent: 43.33 }, { qty: 10, percent: 40 }, { qty: 1, percent: 33.33 }] },
      'waterslide-decals': { label: 'Waterslide Decals', flatPercent: 20 },
      'fimo': { label: 'Fimo / Charms / Slime Mix-Ins', groupedWith: ['fimo', 'nail-charms', 'slime-mix-ins-charms'], tiers: [{ qty: 30, percent: 20 }, { qty: 20, percent: 15 }, { qty: 10, percent: 10 }, { qty: 5, percent: 8 }, { qty: 1, percent: 5 }] },
      'nail-charms': { label: 'Fimo / Charms / Slime Mix-Ins', groupedWith: ['fimo', 'nail-charms', 'slime-mix-ins-charms'], tiers: [{ qty: 30, percent: 20 }, { qty: 20, percent: 15 }, { qty: 10, percent: 10 }, { qty: 5, percent: 8 }, { qty: 1, percent: 5 }] },
      'slime-mix-ins-charms': { label: 'Fimo / Charms / Slime Mix-Ins', groupedWith: ['fimo', 'nail-charms', 'slime-mix-ins-charms'], tiers: [{ qty: 30, percent: 20 }, { qty: 20, percent: 15 }, { qty: 10, percent: 10 }, { qty: 5, percent: 8 }, { qty: 1, percent: 5 }] },
      'glitter-lab': { label: 'Glitter Lab', flatPercent: 20 },
      'candy-couture': { label: 'Candy Couture', flatPercent: 30 },
      'pigments': { label: 'Pigments', flatPercent: 20 },
      'cuticle-oil-collections': { label: 'Cuticle Oil Collections', flatPercent: 20 }
    },
    productDiscounts: {
      '50ml-refill-oil': { label: '50ml Refill', flatPercent: 20 },
      '100ml-oil': { label: '100ml Refill', flatPercent: 20 },
      'wholesale-250ml-cuticle-oil-refill': { label: '250ml Refill', flatPercent: 20 },
      'wholesale-1-litre-refill': { label: '1L Refill', flatPercent: 20 }
    }
  };

  window.UnicornLabProRules = RULES;



  function setProTableHead(tableWrap) {
    const headRow = tableWrap ? tableWrap.querySelector('thead tr') : null;
    if (headRow) headRow.innerHTML = '<th>Quantity</th><th>Pro price</th>';
  }

  function getProductConfig() {
    const node = document.querySelector('[data-ul-pro-product-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { console.warn('[UL Pro] Could not parse product config', error); return null; }
  }

  function getVariantIdFromPage(config) {
    const input = document.querySelector('input.product-variant-id[name="id"], form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? String(input.value) : String((config && config.selectedVariantId) || '');
  }

  function getSelectedVariant(config) {
    if (!config || !Array.isArray(config.variants)) return null;
    const id = getVariantIdFromPage(config);
    return config.variants.find((variant) => String(variant.id) === String(id)) || config.variants[0] || null;
  }

  function getRetailPrice(selected) {
    return selected ? Number(selected.priceCents || 0) / 100 : 0;
  }

  function isCuticleOilProduct(config) {
    if (!config) return false;
    const title = String(config.title || '').toLowerCase();
    const handle = String(config.handle || '').toLowerCase();
    const type = String(config.type || '').toLowerCase();
    const collections = Array.isArray(config.collections) ? config.collections : [];

    const nonOilKeywords = [
      'glitter', 'polish', 'stamping', 'charm', 'fimo', 'slime', 'waterslide', 'decal',
      'swarovski', 'rhinestone', 'crystal', 'palette', 'nipper', 'pusher', 'brush',
      'lamp', 'torch', 'file', 'foil', 'gel', 'prep', 'primer', 'top gel', 'pigment',
      'mica', 'scissors', 'storage', 'tips', 'tweezer', 'wipes', 'room spray', 'soaking bowl',
      'keyring', 'menu', 'labels', 'test tube', 'bag'
    ];
    for (const kw of nonOilKeywords) {
      if (type.includes(kw) || handle.includes(kw) || title.includes(kw)) {
        return false;
      }
    }
    for (const col of collections) {
      if (['glitter-lab', 'candy-couture', 'bling-lab', 'waterslide-decals', 'fimo', 'nail-charms', 'slime-mix-ins-charms', 'pigments'].includes(col)) {
        return false;
      }
    }

    if (type === 'cuticle oil' || type === 'unicorn oil') return true;
    if (title.includes('cuticle oil') || handle.includes('cuticle-oil') || title.includes('unicorn oil') || handle.includes('unicorn-cuticle-oil')) return true;
    if (title.includes('roller') || handle.includes('roller')) return true;
    return false;
  }

  function getOilRuleForVariant(variant, productTitle, config) {
    if (config && !isCuticleOilProduct(config)) return null;
    const combinedTitle = `${productTitle || ''} ${variant && variant.title ? variant.title : ''}`;
    const title = String(combinedTitle).toLowerCase().replace(/\s+/g, ' ').trim();
    if (!title) return null;
    if (title.includes('10 pack') || title.includes('10-pack') || title.includes('x10') || title.includes('x 10')) return RULES.oilSizeRules.pack_5ml_10;
    if (title.includes('1ml') || title.includes('sample')) return RULES.oilSizeRules.sample_1ml;
    if (title.includes('2.5ml') || title.includes('2.5 ml') || title.includes('2.5')) return RULES.oilSizeRules.pen_2_5ml;
    if (title.includes('pink') && (title.includes('pen') || title.includes('2ml') || title.includes('3ml'))) return RULES.oilSizeRules.pen_pink;
    if (title.includes('clear') && (title.includes('pen') || title.includes('3ml'))) return RULES.oilSizeRules.pen_3ml;
    if (title.includes('pen') || title.includes('3ml')) return RULES.oilSizeRules.pen_3ml;
    if (title.includes('30ml')) return RULES.oilSizeRules.bottle_30ml;
    if (title.includes('15ml')) return RULES.oilSizeRules.bottle_15ml;
    if (title.includes('10ml') || title.includes('roller')) return RULES.oilSizeRules.roller_10ml;
    if (title.includes('5ml') || title.includes('mini')) return RULES.oilSizeRules.mini_5ml;
    return null;
  }

  function isExcludedOilBundle(config) {
    if (!config) return false;
    const tags = (config.tags || []).map((tag) => String(tag).toLowerCase());
    const title = String(config.title || '').toLowerCase();
    return tags.includes('mystery oil pack') || tags.includes('bundles') || /mystery|bundle|refill|label|wlk|sheet/i.test(title);
  }

  function productCollectionRule(config) {
    if (!config || !Array.isArray(config.collections)) return null;
    for (const handle of config.collections) {
      if (RULES.collectionDiscounts[handle]) return RULES.collectionDiscounts[handle];
    }
    return null;
  }

  function sortTiersAscending(tiers) {
    return Array.isArray(tiers) ? tiers.slice().sort((a, b) => Number(a.qty) - Number(b.qty)) : [];
  }

  function lowestQtyTier(tiers) {
    return sortTiersAscending(tiers)[0] || null;
  }

  function getBestTier(tiers, quantity) {
    const sorted = sortTiersAscending(tiers).reverse();
    return sorted.find((tier) => Number(quantity) >= Number(tier.qty)) || lowestQtyTier(tiers);
  }

  function buildRows(tiers, isPercent) {
    return sortTiersAscending(tiers).map((tier) => {
      const value = isPercent ? `${tier.percent}% off` : `${money(tier.price)} each`;
      return `<tr><td>${tier.qty}+</td><td>${value}</td></tr>`;
    }).join('');
  }

  function getProductScope() {
    const configNode = document.querySelector('[data-ul-pro-product-config]');
    return (
      configNode?.closest('product-info, .product-info, .product-info-wrapper, .product__info-container, .product-detail-content, .product-single__meta, .product__details, .product-main, section') ||
      document.querySelector('product-info, .product-info, .product-info-wrapper, .product__info-container, .product-detail-content, .product-single__meta, .product__details, .product-main') ||
      document
    );
  }

  function isVisible(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getMainProductPriceEl() {
    const existing = document.querySelector('[data-ul-pro-main-price-target="true"]');
    if (existing) return existing;
    const scope = getProductScope();
    const selectors = ['[data-product-price]', '[data-price]', '[data-price-wrapper]', '.product-price', '.product__price', '.product-single__price', '.price__regular', '.price__sale', '.price-item--regular', '.price-item--sale', '.price-item', '.price'];
    for (const selector of selectors) {
      const candidates = Array.from(scope.querySelectorAll(selector));
      for (const el of candidates) {
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!el.closest('[data-ul-pro-pricing]') && !el.closest('[data-ul-pro-cart-warnings]') && !el.closest('.cart-drawer') && !el.closest('#cart-drawer') && !el.closest('[data-cart-drawer]') && /\$\s*\d|AUD/i.test(text) && isVisible(el)) {
          el.setAttribute('data-ul-pro-main-price-target', 'true');
          return el;
        }
      }
    }
    const all = Array.from(scope.querySelectorAll('*'));
    const fallback = all.find((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      return text.length <= 80 && /\$\s*\d/.test(text) && !el.closest('[data-ul-pro-pricing]') && !el.closest('[data-ul-pro-cart-warnings]') && !el.closest('.cart-drawer') && !el.closest('#cart-drawer') && !el.closest('[data-cart-drawer]') && isVisible(el);
    });
    if (fallback) fallback.setAttribute('data-ul-pro-main-price-target', 'true');
    return fallback || null;
  }

  function renderMainStudentPrice(studentPrice, retailPrice) {
    const priceEl = getMainProductPriceEl();
    if (!priceEl) return;

    const proPriceSpan = priceEl.querySelector('[data-ul-eofy-pro-price], .ul-eofy-product-price__price');
    const regPriceSpan = priceEl.querySelector('[data-ul-eofy-regular-price], .ul-eofy-product-price__compare');
    const labelSpan = priceEl.querySelector('[data-ul-eofy-label], .ul-eofy-product-price__badge');
    const noteSpan = priceEl.querySelector('[data-ul-eofy-note], .ul-eofy-product-price__note');

    if (proPriceSpan) {
      proPriceSpan.textContent = moneyAUD(studentPrice);
      if (regPriceSpan) {
        if (retailPrice && retailPrice > studentPrice) {
          regPriceSpan.textContent = moneyAUD(retailPrice);
          regPriceSpan.hidden = false;
        } else {
          regPriceSpan.textContent = '';
          regPriceSpan.hidden = true;
        }
      }
      if (labelSpan) labelSpan.textContent = 'STUDENT PRICE';
      if (noteSpan) noteSpan.textContent = '10% student discount applies automatically at checkout.';
      priceEl.classList.remove('is-hidden');
      return;
    }

    if (!priceEl.dataset.ulOriginalPriceHtml) priceEl.dataset.ulOriginalPriceHtml = priceEl.innerHTML;

    priceEl.innerHTML = `
      <span class="ul-eofy-product-price ul-pro-main-price">
        <span class="product-actual-price ul-eofy-product-price__price ul-pro-main-price__now">${moneyAUD(studentPrice)}</span>
        ${retailPrice && retailPrice > studentPrice ? `<span class="discount-price ul-eofy-product-price__compare ul-pro-main-price__was">${moneyAUD(retailPrice)}</span>` : ''}
        <span class="ul-eofy-product-price__badge ul-pro-main-price__badge">STUDENT PRICE</span>
        <span class="ul-eofy-product-price__note ul-pro-main-price__note">10% student discount applies automatically at checkout.</span>
      </span>
    `;
  }

  function renderMainProPrice(proPrice, retailPrice, customNote) {
    const priceEl = getMainProductPriceEl();
    if (!priceEl) return;

    const proPriceSpan = priceEl.querySelector('[data-ul-eofy-pro-price], .ul-eofy-product-price__price');
    const regPriceSpan = priceEl.querySelector('[data-ul-eofy-regular-price], .ul-eofy-product-price__compare');
    const labelSpan = priceEl.querySelector('[data-ul-eofy-label], .ul-eofy-product-price__badge');
    const noteSpan = priceEl.querySelector('[data-ul-eofy-note], .ul-eofy-product-price__note');
    const note = customNote || 'Pro discount applies automatically at checkout.';

    if (proPriceSpan) {
      proPriceSpan.textContent = moneyAUD(proPrice);
      if (regPriceSpan) {
        if (retailPrice && retailPrice > proPrice) {
          regPriceSpan.textContent = moneyAUD(retailPrice);
          regPriceSpan.hidden = false;
        } else {
          regPriceSpan.textContent = '';
          regPriceSpan.hidden = true;
        }
      }
      if (labelSpan) labelSpan.textContent = 'PRO PRICE';
      if (noteSpan) noteSpan.textContent = note;
      priceEl.classList.remove('is-hidden');
      return;
    }

    if (!priceEl.dataset.ulOriginalPriceHtml) priceEl.dataset.ulOriginalPriceHtml = priceEl.innerHTML;

    priceEl.innerHTML = `
      <span class="ul-eofy-product-price ul-pro-main-price">
        <span class="product-actual-price ul-eofy-product-price__price ul-pro-main-price__now">${moneyAUD(proPrice)}</span>
        ${retailPrice && retailPrice > proPrice ? `<span class="discount-price ul-eofy-product-price__compare ul-pro-main-price__was">${moneyAUD(retailPrice)}</span>` : ''}
        <span class="ul-eofy-product-price__badge ul-pro-main-price__badge">PRO PRICE</span>
        <span class="ul-eofy-product-price__note ul-pro-main-price__note">${note}</span>
      </span>
    `;
  }

  function restoreMainPrice() {
    const priceEl = getMainProductPriceEl();
    if (priceEl && priceEl.dataset.ulOriginalPriceHtml) {
      priceEl.innerHTML = priceEl.dataset.ulOriginalPriceHtml;
      delete priceEl.dataset.ulOriginalPriceHtml;
    }
  }

  function isSwarovskiProduct(config) {
    if (!config) return false;
    const title = String(config.title || '').toLowerCase();
    const handle = String(config.handle || '').toLowerCase();
    const type = String(config.type || '').toLowerCase();
    return (
      type === 'swarovski' ||
      title.includes('swarovski') ||
      handle.includes('swarovski') ||
      handle === 'rose-gold-pearl-charm-5890-pre-order' ||
      handle === 'rosealine-pearl-charm-5890-pre-order'
    );
  }

  function updateProductPricing() {
    const config = getProductConfig();
    const wrapper = document.querySelector('[data-ul-pro-pricing]');
    if (!config || !wrapper) return;

    // Swarovski products are completely excluded from all Pro & Student discounts
    if (isSwarovskiProduct(config)) {
      restoreMainPrice();
      wrapper.hidden = true;
      return;
    }

    const isMens = (config.collections || []).some((c) => c === 'mens-oil' || c === 'mens-cuticle-oil') ||
                   (config.tags || []).some((t) => String(t).toLowerCase().includes('mens') || String(t).toLowerCase().includes('for men')) ||
                   String(config.handle || '').includes('mens') ||
                   String(config.handle || '').includes('gentlemans') ||
                   String(config.handle || '').includes('atunis') ||
                   Boolean(document.querySelector('.ul-mens-product-theme'));

    if (isMens) {
      wrapper.classList.add('ul-pro-pricing--mens');
    }

    const title = wrapper.querySelector('[data-ul-pro-pricing-title]');
    const message = wrapper.querySelector('[data-ul-pro-pricing-message]');
    const tableWrap = wrapper.querySelector('[data-ul-pro-pricing-table-wrap]');
    const rows = wrapper.querySelector('[data-ul-pro-pricing-rows]');
    const sampleNote = document.querySelector('[data-ul-sample-limit-note]');
    const selected = getSelectedVariant(config);

    wrapper.hidden = true;
    if (sampleNote) sampleNote.hidden = true;
    if (rows) rows.innerHTML = '';
    if (tableWrap) {
      tableWrap.hidden = true;
      setProTableHead(tableWrap);
    }

    const retailPrice = getRetailPrice(selected);
    const fixedPrice = RULES.fixedProductPrices[config.handle];
    const fixedDiscount = RULES.fixedProductDiscounts[config.handle];
    const productDiscount = RULES.productDiscounts[config.handle];
    const collectionRule = productCollectionRule(config);
    const oilRule = !isExcludedOilBundle(config) && isCuticleOilProduct(config) ? getOilRuleForVariant(selected, config.title, config) : null;

    if (oilRule && oilRule.maxPerVariant && sampleNote) sampleNote.hidden = false;
    applyProductQuantityLimits(oilRule);

    if (!config.isPro && !config.isStudent) {
      restoreMainPrice();
      return;
    }

    if (config.isStudent && !config.isPro) {
      renderMainStudentPrice(retailPrice * 0.9, retailPrice);
      wrapper.hidden = true;
      return;
    }

    if (fixedDiscount !== undefined) {
      renderMainProPrice(retailPrice - Number(fixedDiscount), retailPrice, 'Pro bundle discount applied.');
      wrapper.hidden = true;
      return;
    }

    if (fixedPrice !== undefined) {
      const variantTitle = (selected && selected.title ? selected.title : '').toLowerCase();
      const bambooExtra = variantTitle.indexOf('bamboo') !== -1 ? 1.00 : 0;
      renderMainProPrice(Number(fixedPrice) + bambooExtra, retailPrice, 'Fixed Pro price applied.');
      wrapper.hidden = true;
      return;
    }

    if (productDiscount) {
      const proPrice = retailPrice * (1 - Number(productDiscount.flatPercent) / 100);
      renderMainProPrice(proPrice, retailPrice, `Approved Pro customers receive ${productDiscount.flatPercent}% off.`);
      wrapper.hidden = true;
      return;
    }

    if (oilRule) {
      const baseTier = lowestQtyTier(oilRule.tiers);
      if (!baseTier) {
        restoreMainPrice();
        return;
      }

      renderMainProPrice(Number(baseTier.price), retailPrice);

      if (oilRule.tiers && oilRule.tiers.length >= 2) {
        wrapper.hidden = false;
        if (title) title.textContent = `${oilRule.label} Pro pricing`;
        if (message) message.textContent = oilRule.message || '';
        if (tableWrap) {
          setProTableHead(tableWrap);
          tableWrap.hidden = false;
        }
        if (rows) rows.innerHTML = buildRows(oilRule.tiers, false);
      } else {
        wrapper.hidden = true;
      }
      return;
    }

    if (collectionRule) {
      wrapper.hidden = false;
      if (title) title.textContent = `${collectionRule.label} Pro pricing`;

      if (collectionRule.flatPercent) {
        const proPrice = retailPrice * (1 - Number(collectionRule.flatPercent) / 100);
        renderMainProPrice(proPrice, retailPrice);
        if (message) message.textContent = `Approved Pro customers receive ${collectionRule.flatPercent}% off this collection.`;
        return;
      }

      const firstTier = lowestQtyTier(collectionRule.tiers);
      if (firstTier && Number(firstTier.qty) <= 1 && Number(firstTier.percent) > 0) {
        const proPrice = retailPrice * (1 - Number(firstTier.percent) / 100);
        renderMainProPrice(proPrice, retailPrice);
        if (message) message.textContent = `Approved Pro customers receive ${firstTier.percent}% off from 1 item, with higher volume tiers available.`;
      } else {
        restoreMainPrice();
        if (message) message.textContent = 'Mixed products in this eligible collection count together for the Pro volume tier.';
      }
      if (tableWrap) setProTableHead(tableWrap);
      if (rows) rows.innerHTML = buildRows(collectionRule.tiers, true);
      if (tableWrap) tableWrap.hidden = false;
      return;
    }

    restoreMainPrice();
  }

  function applyProductQuantityLimits(oilRule) {
    const qtyInputs = document.querySelectorAll('input[name="quantity"], [data-input-quantity]');
    const isSample = oilRule && oilRule.maxPerVariant === 1;
    qtyInputs.forEach((input) => {
      if (isSample) {
        input.max = '1';
        if (Number(input.value || 1) > 1) input.value = '1';
      } else if (input.max === '1') {
        input.removeAttribute('max');
      }
    });
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function getCartConfig() {
    const nodes = Array.from(document.querySelectorAll('[data-ul-pro-cart-config]'));
    const configs = nodes.map((node) => {
      try { return JSON.parse(node.textContent); } catch (error) { return null; }
    }).filter(Boolean);
    if (!configs.length) return null;
    return configs.find((config) => Array.isArray(config.items) && config.items.length) || configs[0];
  }

  function isSampleCartItem(item) {
    const title = `${item.product_title || item.productTitle || ''} ${item.variant_title || item.variantTitle || ''}`.toLowerCase();
    return /\b1\s*ml\s*sample\b/.test(title);
  }

  function hasCartRuleTargets() {
    return !!document.querySelector('[data-ul-pro-cart-warnings], #cartDrawerErrors, input[name="updates[]"], button[name="checkout"], #checkoutCart');
  }

  function getOilMatchFromTitle(title, productTitle) {
    const clean = `${productTitle || ''} ${title || ''}`.toLowerCase().replace(/\s+/g, ' ').trim();
    if (!clean) return null;
    if (clean.includes('10 pack') || clean.includes('10-pack') || clean.includes('x10') || clean.includes('x 10')) return { key: 'pack_5ml_10', rule: RULES.oilSizeRules.pack_5ml_10 };
    if (clean.includes('1ml') || clean.includes('sample')) return { key: 'sample_1ml', rule: RULES.oilSizeRules.sample_1ml };
    if (clean.includes('2.5ml') || clean.includes('2.5 ml') || clean.includes('2.5')) return { key: 'pen_2_5ml', rule: RULES.oilSizeRules.pen_2_5ml };
    if (clean.includes('pink') && (clean.includes('pen') || clean.includes('2ml') || clean.includes('3ml'))) return { key: 'pen_pink', rule: RULES.oilSizeRules.pen_pink };
    if (clean.includes('clear') && (clean.includes('pen') || clean.includes('3ml'))) return { key: 'pen_3ml', rule: RULES.oilSizeRules.pen_3ml };
    if (clean.includes('pen') || clean.includes('3ml')) return { key: 'pen_3ml', rule: RULES.oilSizeRules.pen_3ml };
    if (clean.includes('30ml')) return { key: 'bottle_30ml', rule: RULES.oilSizeRules.bottle_30ml };
    if (clean.includes('15ml')) return { key: 'bottle_15ml', rule: RULES.oilSizeRules.bottle_15ml };
    if (clean.includes('10ml') || clean.includes('roller')) return { key: 'roller_10ml', rule: RULES.oilSizeRules.roller_10ml };
    if (clean.includes('5ml') || clean.includes('mini')) return { key: 'mini_5ml', rule: RULES.oilSizeRules.mini_5ml };
    return null;
  }

  function isExcludedCartOilBundle(item) {
    const tags = (item.tags || []).map((tag) => String(tag).toLowerCase());
    const title = `${item.productTitle || item.product_title || ''} ${item.handle || ''}`.toLowerCase();
    return tags.includes('mystery oil pack') || tags.includes('bundles') || /mystery|bundle|refill/.test(title);
  }

  function getItemCollections(item) {
    return Array.isArray(item.collections) ? item.collections.map(String) : [];
  }

  function getCollectionDiscountMatch(item) {
    const collections = getItemCollections(item);
    for (const handle of collections) {
      const rule = RULES.collectionDiscounts[handle];
      if (!rule) continue;
      const key = rule.groupedWith ? rule.groupedWith.slice().sort().join('|') : handle;
      return { key, rule };
    }
    return null;
  }

  function classifyCartLine(item, bucketCounts, collectionCounts) {
    const handle = item.handle;
    const baseUnit = Number(item.unitPriceCents || item.price || 0) / 100;
    const qty = Number(item.quantity || 0);
    const fixedPrice = RULES.fixedProductPrices[handle];
    const fixedDiscount = RULES.fixedProductDiscounts[handle];
    const productDiscount = RULES.productDiscounts[handle];
    const oilMatch = !isExcludedCartOilBundle(item) ? getOilMatchFromTitle(item.variantTitle || item.variant_title, item.productTitle || item.product_title) : null;
    const collectionMatch = getCollectionDiscountMatch(item);

    if (fixedDiscount !== undefined) {
      return { type: 'fixed', label: 'Pro bundle discount', proUnit: baseUnit - Number(fixedDiscount), baseUnit, qty };
    }

    if (fixedPrice !== undefined) {
      const variantTitle = String(item.variantTitle || item.variant_title || '').toLowerCase();
      const bambooExtra = variantTitle.indexOf('bamboo') !== -1 ? 1.00 : 0;
      return { type: 'fixed', label: 'Fixed Pro price', proUnit: Number(fixedPrice) + bambooExtra, baseUnit, qty };
    }

    if (productDiscount && productDiscount.flatPercent) {
      const proUnit = baseUnit * (1 - Number(productDiscount.flatPercent) / 100);
      return { type: 'product_percent', label: `${productDiscount.label} ${productDiscount.flatPercent}% off`, proUnit, baseUnit, qty };
    }

    if (oilMatch && oilMatch.rule) {
      const count = bucketCounts[oilMatch.key] || qty;
      const tier = getBestTier(oilMatch.rule.tiers, count);
      return { type: 'oil', label: `${oilMatch.rule.label} Pro price${tier && tier.qty > 1 ? ` (${tier.qty}+ tier)` : ''}`, proUnit: tier ? Number(tier.price) : baseUnit, baseUnit, qty };
    }

    if (collectionMatch && collectionMatch.rule) {
      const rule = collectionMatch.rule;
      if (rule.flatPercent) {
        const proUnit = baseUnit * (1 - Number(rule.flatPercent) / 100);
        return { type: 'collection_flat', label: `${rule.label} ${rule.flatPercent}% off`, proUnit, baseUnit, qty };
      }
      const count = collectionCounts[collectionMatch.key] || qty;
      const tier = getBestTier(rule.tiers, count);
      const percent = tier ? Number(tier.percent) : 0;
      const proUnit = baseUnit * (1 - percent / 100);
      return { type: 'collection_tier', label: `${rule.label} ${percent}% off${tier ? ` (${tier.qty}+ tier)` : ''}`, proUnit, baseUnit, qty };
    }

    return { type: 'none', label: '', proUnit: baseUnit, baseUnit, qty };
  }

  function estimateProCart(config) {
    if (!config || !config.isPro || !Array.isArray(config.items)) return null;

    const bucketCounts = {};
    const collectionCounts = {};

    config.items.forEach((item) => {
      const qty = Number(item.quantity || 0);
      const handle = item.handle;
      const isFixed = RULES.fixedProductPrices[handle] !== undefined;
      const isFixedDiscount = RULES.fixedProductDiscounts[handle] !== undefined;
      const hasProductDiscount = !!RULES.productDiscounts[handle];
      const oilMatch = !isFixed && !isFixedDiscount && !hasProductDiscount && !isExcludedCartOilBundle(item) ? getOilMatchFromTitle(item.variantTitle || item.variant_title, item.productTitle || item.product_title) : null;

      if (oilMatch) bucketCounts[oilMatch.key] = (bucketCounts[oilMatch.key] || 0) + qty;

      if (!isFixed && !isFixedDiscount && !hasProductDiscount && !oilMatch) {
        const collectionMatch = getCollectionDiscountMatch(item);
        if (collectionMatch && collectionMatch.rule && !collectionMatch.rule.flatPercent) {
          collectionCounts[collectionMatch.key] = (collectionCounts[collectionMatch.key] || 0) + qty;
        }
      }
    });

    const lines = config.items.map((item) => {
      const calc = classifyCartLine(item, bucketCounts, collectionCounts);
      const retailTotal = calc.baseUnit * calc.qty;
      const proTotal = calc.proUnit * calc.qty;
      return { title: item.variantTitle ? `${item.productTitle} - ${item.variantTitle}` : item.productTitle, quantity: calc.qty, baseUnit: calc.baseUnit, proUnit: calc.proUnit, retailTotal, proTotal, savings: Math.max(0, retailTotal - proTotal), label: calc.label, type: calc.type };
    });

    const retailTotal = lines.reduce((sum, line) => sum + line.retailTotal, 0);
    const proTotal = lines.reduce((sum, line) => sum + line.proTotal, 0);
    const savings = Math.max(0, retailTotal - proTotal);
    return { lines, retailTotal, proTotal, savings };
  }

  function estimateStudentCart(config) {
    if (!config || !config.isStudent || config.isPro || !Array.isArray(config.items)) return null;

    const lines = config.items.map((item) => {
      const baseUnit = Number(item.unitPriceCents || item.price || 0) / 100;
      const qty = Number(item.quantity || 0);
      const studentUnit = Math.round(baseUnit * 0.9 * 100) / 100;
      const retailTotal = baseUnit * qty;
      const studentTotal = studentUnit * qty;
      return {
        title: item.variantTitle ? `${item.productTitle} - ${item.variantTitle}` : item.productTitle,
        quantity: qty,
        baseUnit,
        proUnit: studentUnit,
        retailTotal,
        proTotal: studentTotal,
        savings: Math.max(0, retailTotal - studentTotal),
        label: 'Student 10% off',
        type: 'student',
      };
    });

    const retailTotal = lines.reduce((sum, l) => sum + l.retailTotal, 0);
    const proTotal = lines.reduce((sum, l) => sum + l.proTotal, 0);
    const savings = Math.max(0, retailTotal - proTotal);
    return { lines, retailTotal, proTotal, savings, isStudent: true };
  }

  async function validateCart() {
    if (!hasCartRuleTargets()) return [];

    const config = getCartConfig();
    const cartFromAjax = config ? null : await fetchCart();

    const cartItems = config && Array.isArray(config.items)
      ? config.items.map((item) => ({ variant_id: item.variantId, variant_title: item.variantTitle, product_title: item.productTitle, quantity: item.quantity }))
      : cartFromAjax && Array.isArray(cartFromAjax.items)
        ? cartFromAjax.items
        : [];

    if (!cartItems.length && !(config && config.items && config.items.length === 0)) return [];

    const errors = [];
    cartItems.forEach((item, index) => {
      if (isSampleCartItem(item) && Number(item.quantity) > 1) {
        errors.push({ line: index + 1, variantId: item.variant_id, message: `${item.product_title || item.productTitle} - ${item.variant_title || item.variantTitle} is limited to 1 per scent.` });
      }
    });

    applyCartInputLimits(cartItems);
    const estimate = config?.isPro
      ? estimateProCart(config)
      : estimateStudentCart(config);
    renderCartPanel(errors, estimate);
    toggleCheckout(errors.length === 0);
    return errors;
  }

  function applyCartInputLimits(items) {
    const inputs = document.querySelectorAll('input[name="updates[]"]');
    inputs.forEach((input, index) => {
      const item = items[index];
      if (item && isSampleCartItem(item)) {
        input.max = '1';
        if (Number(input.value || 1) > 1) input.value = '1';
      }
    });
  }

  function renderCartPanel(errors, estimate) {
    const boxes = document.querySelectorAll('[data-ul-pro-cart-warnings], #cartDrawerErrors');
    boxes.forEach((box) => {
      if (!box) return;

      if (errors.length) {
        box.innerHTML = `<strong>Please fix your cart before checkout.</strong><ul>${errors.map((error) => `<li>${error.message}</li>`).join('')}</ul>`;
        box.setAttribute('data-severity', 'error');
        box.hidden = false;
        return;
      }

      if (!estimate || estimate.savings <= 0) {
        if (box.hasAttribute('data-ul-pro-cart-warnings')) box.hidden = true;
        if (box.id === 'cartDrawerErrors') box.innerHTML = '';
        return;
      }

      const isStudent = estimate.isStudent === true;
      const headingLabel = isStudent ? 'Estimated Student pricing' : 'Estimated Pro pricing';
      const priceLabel = isStudent ? 'Student' : 'Pro';
      const discountedLines = estimate.lines.filter((line) => line.savings > 0).slice(0, 6);
      const lineHtml = discountedLines.map((line) => `<li><span>${line.title}</span><strong>${money(line.proUnit)} each</strong><small>${line.label}</small></li>`).join('');

      box.innerHTML = `
        <div class="ul-pro-cart-estimate">
          <strong>${headingLabel}</strong>
          <div class="ul-pro-cart-estimate__totals">
            <span>Retail: <s>${money(estimate.retailTotal)}</s></span>
            <span>Estimated ${priceLabel}: <strong>${money(estimate.proTotal)}</strong></span>
            <span>You save: <strong>${money(estimate.savings)}</strong></span>
          </div>
          <ul class="ul-pro-cart-estimate__lines">${lineHtml}</ul>
        </div>
      `;

      box.removeAttribute('data-severity');
      box.hidden = false;
    });
  }

  function toggleCheckout(enabled) {
    const buttons = document.querySelectorAll('button[name="checkout"], #checkoutCart');
    buttons.forEach((button) => {
      button.disabled = !enabled;
      if (!enabled) button.setAttribute('data-ul-disabled', 'true');
      else button.removeAttribute('data-ul-disabled');
    });
  }

  async function guardProductAdd(event) {
    const config = getProductConfig();
    if (!config) return;

    const selected = getSelectedVariant(config);
    const oilRule = !isExcludedOilBundle(config) && isCuticleOilProduct(config) ? getOilRuleForVariant(selected, config.title, config) : null;
    if (!oilRule || oilRule.maxPerVariant !== 1 || !selected) return;

    const form = event.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    if (!form) return;

    const qtyInput = form.querySelector('input[name="quantity"]');
    const requestedQty = Math.max(1, Number(qtyInput && qtyInput.value ? qtyInput.value : 1));
    const cart = await fetchCart();

    const existingQty = cart && cart.items
      ? cart.items.filter((item) => String(item.variant_id) === String(selected.id)).reduce((sum, item) => sum + Number(item.quantity || 0), 0)
      : 0;

    if (existingQty + requestedQty > 1) {
      event.preventDefault();
      event.stopPropagation();

      const note = document.querySelector('[data-ul-sample-limit-note]');
      if (note) {
        note.hidden = false;
        note.textContent = 'You already have this 1ml sample in your cart. 1ml samples are limited to 1 per scent.';
        note.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        alert('You already have this 1ml sample in your cart. 1ml samples are limited to 1 per scent.');
      }
    }
  }

  function debounce(fn, wait) {
    let timeout;
    return function debounced() {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  // Mutex flag — prevents our own DOM writes from re-triggering the observer
  var _ulPricingUpdating = false;

  function scheduleProductPricingRefresh() {
    // Run after Shopify's 300ms debounce finishes updating input[name="id"]
    window.setTimeout(updateProductPricing, 320);
  }

  function initProductPricing() {
    // Initial render: retry until the wrapper exists in the DOM
    var delays = [0, 300, 800, 1800, 3500];
    var rendered = false;
    delays.forEach(function(delay) {
      window.setTimeout(function() {
        if (rendered) return;
        var wrapper = document.querySelector('[data-ul-pro-pricing]');
        if (wrapper) { updateProductPricing(); rendered = true; }
      }, delay);
    });
  }

  function observeShopifyPriceReplacement() {
    // Shopify's renderProductInfo() replaces innerHTML of #price-{sectionId}
    // when a variant changes. This wipes our pricing widget.
    // We observe that element and immediately re-render after Shopify is done.
    var priceEl = document.querySelector('[id^="price-"]');
    if (!priceEl) return;
    new MutationObserver(function() {
      if (_ulPricingUpdating) return;
      _ulPricingUpdating = true;
      window.setTimeout(function() {
        updateProductPricing();
        _ulPricingUpdating = false;
      }, 30);
    }).observe(priceEl, { childList: true, subtree: false });
  }

  function observeVariantChanges() {
    const refreshProductPricing = debounce(scheduleProductPricingRefresh, 40);

    document.addEventListener('change', (event) => {
      if (event.target.matches('select, input[type="radio"], input.product-variant-id, input[name="id"]')) refreshProductPricing();
      if (event.target.matches('input[name="updates[]"]')) setTimeout(validateCart, 50);
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-option-value], .product-variant-option, variant-selector, variant-radios, variant-selects, .swatches-list-item, .swatch-input, [data-variant-id], [data-variant-option], label')) refreshProductPricing();
    });

    ['variant:change', 'variant:changed', 'product:variant-change', 'product:variant:change', 'variantChange'].forEach((eventName) => {
      document.addEventListener(eventName, refreshProductPricing);
    });

    const variantInputs = document.querySelectorAll('input.product-variant-id[name="id"], form[action*="/cart/add"] input[name="id"]');
    variantInputs.forEach((input) => {
      let lastValue = input.value;
      const checkVariantValue = () => {
        if (input.value !== lastValue) {
          lastValue = input.value;
          scheduleProductPricingRefresh();
        }
      };
      input.addEventListener('change', checkVariantValue);
      input.addEventListener('input', checkVariantValue);
      new MutationObserver(checkVariantValue).observe(input, { attributes: true, attributeFilter: ['value'] });
    });
  }

  function observeCartChanges() {
    const debouncedValidateCart = debounce(validateCart, 80);

    // 1. Observe cart drawer DOM mutations (when section rendering replaces drawer HTML)
    const cartDrawers = document.querySelectorAll('cart-drawer, #cart-drawer, .cart-drawer, #CartDrawer');
    cartDrawers.forEach((drawer) => {
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' || (mutation.type === 'attributes' && mutation.attributeName === 'class')) {
            debouncedValidateCart();
            break;
          }
        }
      }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
    });

    // 2. PubSub subscription if present
    if (typeof pubsub !== 'undefined' && pubsub.subscribe) {
      try {
        if (typeof PUB_SUB_EVENTS !== 'undefined') {
          if (PUB_SUB_EVENTS.cartUpdate) pubsub.subscribe(PUB_SUB_EVENTS.cartUpdate, debouncedValidateCart);
          if (PUB_SUB_EVENTS.quantityUpdate) pubsub.subscribe(PUB_SUB_EVENTS.quantityUpdate, debouncedValidateCart);
        }
      } catch (e) {}
    }

    // 3. Global click & event listeners for cart interactions
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-btn], a[href*="/cart"], .cart-icon, .header-cart, [data-close-drawer], .cart-remove-item, [data-remove-item]')) {
        [50, 200, 500, 1000].forEach((delay) => setTimeout(validateCart, delay));
      }
    });

    ['cart:updated', 'cart:update', 'cart:change', 'cart:changed', 'cart:refresh'].forEach((ev) => {
      document.addEventListener(ev, debouncedValidateCart);
      window.addEventListener(ev, debouncedValidateCart);
    });
  }

  function init() {
    initProductPricing();
    observeShopifyPriceReplacement();
    observeVariantChanges();
    observeCartChanges();

    if (hasCartRuleTargets()) {
      [0, 200, 600].forEach((delay) => setTimeout(validateCart, delay));
    }
    document.addEventListener('submit', guardProductAdd, true);

    document.addEventListener('click', (event) => {
      if (event.target.closest('button[name="checkout"], #checkoutCart')) {
        validateCart().then((errors) => {
          if (errors.length) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      }

      if (event.target.closest('[data-quantity-increment], .plus-button, [data-quantity-decrement], .minus-button')) {
        setTimeout(() => {
          scheduleProductPricingRefresh();
          validateCart();
        }, 150);
      }
    }, true);

    document.addEventListener('cart:updated', validateCart);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();





